// 接口文档： https://supptech.sg.larksuite.com/wiki/Nobsw0FhdilBpak9V2nlUc29gxh
import type { AxiosResponse } from 'axios';
import axiosInstance from './axiosInstance';

const baseUrl = `${SUPP_ADMIN_BASE_URL}/supp-management`;

/**
 * 列表
 * @param {*} params
 * @returns
 */
export const getList = async (params) => {
  const response = await axiosInstance.get(`${baseUrl}/p/v1/list`, { params });

  return response;
};

/**
 * 详情
 * @param {*} params
 * @returns
 */
export const getDetail = async (params: {
  id: string;
}): Promise<
  AxiosResponse<ResponseDTOPushConfigDetailResp, PushConfigDetailResp>
> => {
  const response = await axiosInstance.get(`${baseUrl}/p/v1/detail`, {
    params,
  });

  return response;
};

/**
 * 批量下线
 * @param {*} params
 * @returns
 */
export const batchOffline = async (params) => {
  const response = await axiosInstance.post(
    `${baseUrl}/p/v1/batchOffline`,
    params
  );

  return response;
};

/**
 * 新增编辑
 * @param {*} params
 * @returns
 */
export const addOrEdit = async (
  params: PushConfigEditDTO
): Promise<AxiosResponse<ResponseDTO>> => {
  const response = await axiosInstance.post(
    `${baseUrl}/p/v1/addOrEdit`,
    params
  );

  return response;
};
